import { Record } from "immutable";

import printDimensions from "../../../constants/printing/printDimensions";
import printOrientation from "../../../constants/printing/printOrientation";
import createFromJS from "../../createFromJS";

export const PrintOptionsRecord = Record({
  paperSize: printDimensions.paperSize.A4,
  orientation: printOrientation.Portrait,
  scale: 1
});

createFromJS.registerCallback("PrintOptionsRecord", createFromJS.createPrimitiveCallback(PrintOptionsRecord));
